import React from 'react'
import {Spin} from "antd"
import LayoutTableHead from "./LayoutTableHead"
import LayoutTableBody from "./LayoutTableBody"

const LayoutTable = (props) => {
    const {loading, error, listLayout} = props

    return (
        <div className="LeadTable">
            <Spin spinning={loading} tip="Đang lấy dữ liệu...">
                <table className="table">
                    <LayoutTableHead/>
                    <LayoutTableBody
                        loading={loading}
                        error={error}
                        listLayout={listLayout}
                    />
                </table>
            </Spin>
        </div>
    )
}

export default LayoutTable